@if (typedForm && userFormGroup) {
    <form *ngIf="selectItems | async as _selectItems" [formGroup]="typedForm" (submit)="save()">
        <div [ngStyle]="{width: '1024px', maxWidth: 'calc(100vw - 80px)'}">
            <p-stepper [value]="currentStep" class="basis-[50rem]" [linear]="false">
                <p-step-list>
                    <p-step [value]="1">Időpont kiválasztása</p-step>
                    <p-step [value]="2">Kapcsolattartási adatok</p-step>
                    <p-step [value]="3">Összesítés</p-step>
                </p-step-list>
                <p-step-panels>
                    <p-step-panel [value]="1">
                        <ng-template #content>
                            <div class="p-2">
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Időpont</label>
                                    <div class="flex-auto mb-4">
                                        <p-datePicker [formControl]="typedForm.controls.plannedStart" [fluid]="true"
                                                      [showTime]="false" (onMonthChange)="monthChanged($event)"
                                                      [firstDayOfWeek]="1"
                                                      [showIcon]="!isReadOnly()" iconDisplay="input" [inline]="!isReadOnly()"
                                                      dateFormat="yy.mm.dd" [readonlyInput]="isReadOnly()" [showOnFocus]="!isReadOnly()"
                                                      [disabledDates]="datesWithoutEvent" [selectOtherMonths]="true"></p-datePicker>
                                    </div>
                                </div>
                                @if (!isReadOnly()) {
                                    <div class="only-big-flex items-center gap-4 mb-4">
                                        <label class="font-semibold w-4">Időpont kiválasztása</label>
                                        <div class="flex-auto">
                                            <p-select #options [options]="availableTimesSignal()" optionLabel="label" [fluid]="true"
                                                      [dataKey]="'slotId'" [optionValue]="'slotId'" [readonly]="isReadOnly()"
                                                      [showClear]="!isReadOnly()" scrollHeight="150px"
                                                      [formControl]="typedForm.controls.event.controls.slotId"
                                                      [ngClass]="false ? 'p-disabled' : ''"
                                                      (onChange)="eventTimeSelected($any(options.options),$event.value)"
                                            ></p-select>
                                        </div>
                                    </div>
                                } @else {
                                    <div class="flex items-center gap-4 mb-4">
                                        <label class="font-semibold w-4">Időpont kiválasztása</label>
                                        <input class="flex-auto" pInputText [value]="makeEventTimeLabel(selectedEvent!)"
                                               [readOnly]="true">
                                    </div>
                                }
                                <!--div class="flex flex-wrap gap-4 mb-4">
                                    <label class="font-semibold w-4">Intervallum kiválasztása
                                        <i class="pi pi-info-circle" [pTooltip]="selectedActivity?.canPartTime ? 'Az eseményen lehetőség van annak csak egy kisebb részén is részt venni.' :
                                    'Ezen az eseményen a szervező csak teljes idejű részvételt engedélyez!'"></i>
                                    </label>
                                </div -->
                                @if (!fullTime) {
                                    <div class="only-big-flex items-center gap-4 mb-4">
                                        <label class="font-semibold w-4">Részidőpont kiválasztása</label>
                                        <div class="flex-auto">
                                            <p-select [options]="partTimeOptions" optionLabel="label" [fluid]="true"
                                                      [filter]="true"
                                                      showClear="true" scrollHeight="150px"
                                            ></p-select>
                                        </div>
                                    </div>
                                }
                                <div class="flex justify-end gap-2" [ngStyle]="{marginTop: '8rem'}">
                                    <button pButton class="p-button-outlined"
                                            label="Mégse" [ngStyle]="{width: '200px'}"
                                            severity="secondary" (click)="close()" type="button"></button>
                                    <button pButton
                                            [disabled]="typedForm.controls.event.controls.slotId.value === null && !isReadOnly()"
                                            type="button" [ngStyle]="{width: '200px'}"
                                            [label]="applicationView ? 'Lemondás' : 'Tovább'"
                                            (click)="currentStep=2"></button>
                                </div>
                            </div>
                        </ng-template>
                    </p-step-panel>
                    <p-step-panel [value]="2">
                        <ng-template #content>
                            <div class="p-2">
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Szervezet neve</label>
                                    <div class="flex-auto mb-4">
                                        <input
                                            [formControl]="typedForm.controls.event.controls.activity.controls.partnerClient.controls.name"
                                            pInputText class="" autocomplete="off"
                                            [readOnly]="true" [fluid]="true"/>
                                    </div>
                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Kapcsolattartó elérhetősége</label>
                                    <div class="flex-auto mb-4">
                                        <input pInputText [fluid]="true" autocomplete="off"
                                               [formControl]="typedForm.controls.event.controls.activity.controls.partnerClient.controls.email"
                                               [readOnly]="true"/>
                                    </div>

                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Hallgató neve</label>
                                    <div class="flex-auto mb-4">
                                        <input [formControl]="userFormGroup.controls.name" pInputText [fluid]="true"
                                               autocomplete="off" [readOnly]="true"/>
                                    </div>
                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Neptun kód</label>
                                    <div class="flex-auto mb-4">
                                        <input [formControl]="typedForm.controls.user.controls.neptunIdentifier" pInputText
                                               [fluid]="true" autocomplete="off"
                                               [readOnly]="true"/>
                                    </div>

                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">E-mail cím</label>
                                    <div class="flex-auto mb-4">
                                        <input pInputText [fluid]="true" autocomplete="off"
                                               [formControl]="typedForm.controls.user.controls.email" [readonly]="true"/>
                                    </div>
                                </div>
                                <div class="flex justify-end gap-2" [ngStyle]="{marginTop: '8rem'}">
                                    <button pButton class="p-button-outlined"
                                            label="Vissza" [ngStyle]="{width: '200px'}"
                                            severity="secondary" (click)="currentStep = 1" type="button"></button>
                                    <button pButton
                                            type="button" [ngStyle]="{width: '200px'}"
                                            [label]="applicationView ? 'Lemondás' : 'Tovább' "
                                            (click)="currentStep=3; log()"></button>
                                </div>
                            </div>
                        </ng-template>
                    </p-step-panel>
                    <p-step-panel [value]="3">
                        <ng-template #content>
                            <div class="p-2">
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Tevékenység megnevezése</label>
                                    <div class="flex-auto mb-4">
                                        <input pInputText autocomplete="off"
                                               [formControl]="typedForm.controls.event.controls.activity.controls.name"
                                               [readOnly]="true" [fluid]="true"/>
                                    </div>
                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Esemény helyszíne</label>
                                    <div class="flex-auto mb-4">
                                        <input pInputText class="flex-auto" autocomplete="off"
                                               [formControl]="typedForm.controls.event.controls.address"
                                               [readOnly]="true" [fluid]="true"/>
                                    </div>
                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Részvétel időtartama (Teljes Idő)</label>
                                    <div class="flex-auto mb-4">
                                        <input pInputText class="flex-auto" autocomplete="off"
                                               [value]="dateIntervalToString(typedForm.controls.plannedStart.value, typedForm.controls.plannedEnd.value)"
                                               [readOnly]="true" [fluid]="true"/>
                                    </div>
                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">Partner</label>
                                    <div class="flex-auto mb-4">
                                        <input pInputText class="flex-auto" autocomplete="off"
                                               [formControl]="typedForm.controls.event.controls.activity.controls.partnerClient.controls.name"
                                               [readOnly]="true" [fluid]="true"/>
                                    </div>
                                </div>
                                <div class="only-big-flex items-center gap-4 mb-4">
                                    <label class="font-semibold w-4">E-mail cím</label>
                                    <div class="flex-auto mb-4">
                                        <input pInputText class="flex-auto" autocomplete="off" [fluid]="true"
                                               [formControl]="typedForm.controls.user.controls.email"/>
                                    </div>
                                </div>
                                @if (!isReadOnly()) {
                                    <div class="flex items-center gap-4 mb-4">
                                        <p-checkbox [binary]="true" [(ngModel)]="acceptTerms"
                                                    [ngModelOptions]="{standalone: true}"></p-checkbox>
                                        <label class="">Tudomásul veszem, hogy az esemény lemondására legkésőbb az esemény
                                            kezdete
                                            előtt <span class="font-semibold"
                                                        [ngStyle]="{color: '#3F7467FF'}">{{selectedActivity?.cancelHoursBeforeEvent ? selectedActivity?.cancelHoursBeforeEvent : 48 }} órával</span>
                                            van
                                            lehetőség, és az eseményen való nem megjelenés <span class="font-semibold"
                                                                                                 [ngStyle]="{color: '#3F7467FF'}">hiányzásként</span>
                                            lesz feltüntetve.</label>
                                    </div>
                                }
                                <div class="flex justify-end gap-2" [ngStyle]="{marginTop: '8rem'}">
                                    <button pButton class="p-button-outlined"
                                            label="Vissza" [ngStyle]="{width: '200px'}"
                                            severity="secondary" (click)="currentStep = 2" type="button"></button>
                                    @if (!isReadOnly()) {
                                        <button pButton
                                                [ngStyle]="{width: '200px'}"
                                                [label]="applicationFacade.isInEditMode() ? 'Módosítás' : 'Jelentkezés' "
                                                [disabled]="!acceptTerms"></button>
                                        @if (applicationFacade.isInEditMode()) {
                                            <button pButton
                                                    [label]="'Jelentkezés lemondása'" type="button" [ngStyle]="{width: '200px'}"
                                                    [disabled]="!acceptTerms" (click)="deleteApplication()"></button>
                                        }
                                    }
                                </div>
                            </div>
                        </ng-template>
                    </p-step-panel>
                </p-step-panels>
            </p-stepper>
        </div>
    </form>
}
<p-toast key="center" />
